<template>
    <div>
        <div class="scelta-lingua-container">
            <img class="logo" src="@/assets/main-logo.svg" alt="">
            <h1>Prima di iniziare, scegli la lingua</h1>
            <p>Before you start, choose your language</p>
            <p>Bevor Sie beginnen, wählen Sie Ihre Sprache</p>

            <div class="languages">
                <p  @click="lastoria('it')">
                    <img class="lang" src="@/assets/lang-it.svg" alt="">
                    italiano
                </p>
                <p  @click="lastoria('en')">
                    <img class="lang" src="@/assets/lang-en.svg" alt=""> 
                    english
                </p>
                <p  @click="lastoria('de')">
                    <img class="lang" src="@/assets/lang-de.svg" alt=""> 
                    deutsch
                </p>
            </div>

        </div>
    </div>
</template>

<script>
import { fetchRoutes, fetchSinglePage } from '../libs/drupalClient'
export default {
    name: 'home-page',
    data: () => {
        return {
            lastoriaID: "c111f013-0c30-4372-b82a-df5445f1f435",
            cosafareID: "22a0e792-be9f-4862-b385-b663f544e0c7",
            lastoriaData: {},
            routesData: [],
            currentLang: 'it'
        }
    },
    metaInfo() {
      return {
        title: 'San Canzian d\'Isonzo - Guida Museo',
        titleTemplate: '%s',
        meta: [
          {
            property: 'og:title',
            content: 'Scopri San Canzian d\'Isonzo - Guida Museo'
          }
        ]
      }
    },
    computed: {
        lang() {
            return this.$store.state.currentLang
        }, 
        defaultLang() {
            return this.$store.state.defaultLang
        }
    },
    methods: {
        changeLang(l) {
            this.$store.commit('SET_CURRENT_LANG', l)
        },
        lastoria(lang) {
            //before the page and the routes have arrived there is nowhere to go yet: the click does nothing
            if (!this.lastoriaData.attributes) return
            var route = this.routesData.find(f => f.nid==this.lastoriaData.attributes.drupal_internal__nid && lang == f.lang)
            if (!route) return

            this.changeLang(lang)
            this.$router.push(route.path)
        }
    },
    mounted() {
        fetchRoutes()
        .then(r => this.routesData = r.routes)

        fetchSinglePage(this.lastoriaID, this.lang)
        .then(res => { this.lastoriaData = res })
    },
    watch: {
        lang() {
            this.$router.push({
                path: '/' + (this.lang==this.defaultLang ? '' : this.lang)
            })

            fetchSinglePage(this.lastoriaID, this.lang)
                .then(res => this.lastoriaData = res)
        }
    }
}
</script>

<style lang="scss" scoped>
.scelta-lingua-container {
    &:after {
        display: block;
        content: "";
        background: url(../assets/filigrana-1.png);
        width: 100vw;
        height: 300px;
        pointer-events: none;
        position: absolute;
        top: -120px;
        left: -70px;
        z-index: 99;
        background-size: contain;
        background-repeat: no-repeat;
    }

    &:before {
        display: block;
        content: "";
        background: #181923 url(../assets/filigrana-header.png);
        width: 80%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
    }

    background: #181923 url(../assets/background-pattern.jpg);
    height: auto;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: absolute;
    min-height: 100vh;

    img.logo {
        max-width: 300px;
        width: 80vw;
        margin-top: 2rem;
        margin-bottom: 3rem;
    }

    h1 {
        text-align: center;
        color: #c3923f;
        font-size: 24px;
    }

    p {
        text-align: center;
        padding: 0 15px;
        color: #F3F3F3;
        margin: 5px 0;
        font-size: 16px;
    }

    .languages {
        margin-top: 1rem;
        text-transform: uppercase;
        width: 100%;

        p {
            display: block;
            width: 100%;
            border-bottom: 1px solid #445068;
            position: relative;
            padding: 20px 0px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            a {
                padding: 1.5rem 0rem;
                text-align: center;
                color: #fff;
                text-decoration: none;
                display: flex;
                font-size: 22px;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }
        }

        p:last-child {
            border-bottom: 0px solid #445068;
        }   

        .lang {
            width: 34px;
            height: 34px;
            top: 0;
            left: 0;
            z-index: 99;
            position: relative;
            pointer-events: none;
            top: -3px;
            left: -12px;
        }
    }
}
</style>